"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themeProfile = void 0;
exports.themeProfile = {
    name: 'theme',
    methods: ['currentTheme'],
    events: ['themeChanged']
};
//# sourceMappingURL=profile.js.map